import { makeStyles } from "tss-react/mui";
import { MiButton, MiStepper } from "@miplatform/components";
import { BUTTON_VARIANTS } from "@miplatform/constants";
import { Box } from "@mui/material";

export function StepperView({
  children,
  activeStep,
  setActiveStep,
  disabled,
  disableNavigation,
  steps,
  nextLabel = "Next",
  customLeftBtn,
}: StepperViewProps) {
  const { classes } = useStyles();

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <>
      {children}
      <Box className={classes.btnContainer}>
        <Box className={classes.submitBtnContainer}>{customLeftBtn}</Box>
        <MiStepper
          activeStep={activeStep}
          steps={steps}
          setActiveStep={setActiveStep}
          disabled={disableNavigation}
        />
        <Box className={classes.submitBtnContainer}>
          {activeStep > 0 && (
            <MiButton
              variant={BUTTON_VARIANTS.OUTLINED}
              title="Back"
              onClick={handleBack}
              className={classes.backBtn}
            />
          )}
          <MiButton
            variant={BUTTON_VARIANTS.CONTAINED}
            title={nextLabel}
            onClick={handleNext}
            disabled={disabled}
          />
        </Box>
      </Box>
    </>
  );
}

const useStyles = makeStyles()((theme) => ({
  btnContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.grey.accent}`,
    backgroundColor: theme.palette.common.white,
  },
  submitBtnContainer: {
    display: "flex",
    gap: theme.spacing(1),
  },
  backBtn: {
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));

interface Steps {
  value: number;
  label: string;
}

interface StepperViewProps {
  children: React.ReactNode;
  activeStep: number;
  setActiveStep: (step: number) => void;
  disabled?: boolean;
  disableNavigation?: boolean;
  steps: Steps[];
  nextLabel?: string;
  customLeftBtn?: React.ReactNode;
}
